module.exports = __webpack_public_path__ + "img/work_driving.33f794b9.svg";